import React from "react";
import "./HomeAccordion.css";
import { faqList } from "../../utils/faq";
import Accordion from "./Accordion ";

const HomeAccordion = () => {
  return (
    <div className="hmAccordion-container">
      <div className="faqWrapper">
        <h1>
          Frequently Asked <br className="fqbbr" /> Questions
        </h1>
        <span className="faqbg">Frequently Asked Questions</span>
      </div>

      <Accordion items={faqList} />
    </div>
  );
};

export default HomeAccordion;
